import SectionDescriptionBody from './SectionDescriptionBody';

const View = (props) => <SectionDescriptionBody {...props} />;

export default View;
